import Plugin, { init } from "@/modules/_utils/Plugin";

class modalScreen extends Plugin {
  init() {
    const modal = document.querySelectorAll(".modal_screen");

    const modalClose = document.querySelectorAll(".modal__close");

    const iframe = document.getElementById("video_iframe");

    function clickHandler(e) {
      let videoSource = this.getAttribute("data-video");
      iframe.setAttribute("src", videoSource);
      document.body.classList.add("modal__active");
    }

    function closeClickHandler(e) {
      iframe.setAttribute("src", "");
      document.body.classList.remove("modal__active");
    }

    Array.prototype.forEach.call(modal, function(modalScreen) {
      modalScreen.addEventListener("click", clickHandler);
    });

    Array.prototype.forEach.call(modalClose, function(cloaseModal) {
      cloaseModal.addEventListener("click", closeClickHandler);
    });
  }
}

export default init(modalScreen, "modalScreen");
